<template><section><template>
<h3>Datepicker</h3>
<div class="bs-docs-section">
<div class="bs-example">
<p>
<pre>
Selected date is: {{new Date(value).toString().slice(0, -23)}}
</pre>
</p>
<n3-datepicker v-model="value" format="yyyy-MM-dd">
</n3-datepicker>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-datepicker</span>
  <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>
  <span class="hljs-attr">format</span>=<span class="hljs-string">"yyyy-MM-dd"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-datepicker</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">n3-select</span> <span class="hljs-attr">multiple</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"disabled"</span> &gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"0"</span>&gt;</span>0<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"1"</span>&gt;</span>1<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"2"</span>&gt;</span>2<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"3"</span>&gt;</span>3<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"4"</span>&gt;</span>4<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"5"</span>&gt;</span>5<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"6"</span>&gt;</span>6<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-select</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">200px</code></td>
<td>width of input</td>
</tr>
<tr>
<td>format</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">yyyy-MM-dd</code></td>
<td>format value (d, dd, M, MM ,MMM , MMMM, yyyy. )</td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>readonly</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>value change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>

export default {
  data () {
    return {
      value: '2016-03-25'
    }
  },
  methods: {
    change (val) {
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3DatepickerDocs.md?f668ac68